import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import reducer from './account';
import ComponentsReducer from './ComponentsReducer';
import OfferWallReducer from './OfferWallReducer';
import OfferTitleReducer from './OfferTitleReducer';
import CriteriaReducer from './CriteriaReducer';
import OfferActionReducer from './OfferActionReducer';
import AdvertisersReducer from './AdvertisersReducer';
import TagsReducer from './TagsReducer';
import OfferWallAdReducer from '../views/OfferWallAds/actions/reducers';
import LandingPageReducer from '../views/LandingPages/actions/reducers';
import LandingPageGroupReducer from '../views/LandingPageGroups/actions/reducers';
import AdvertiserReducer from '../views/Advertisers/actions/reducers';
import MetadataReducer from '../views/Metadata/actions/reducers';
import FormSelectorReducer from './FormSelectorReducer';
import AdvertiserPrePingReducer from '../views/AdvPrePing/actions/reducers';
import SequenceReducer from '../views/Sequences/actions/reducers';

const initialSidebarState = {
  sidebarShow: true,
  asideShow: false,
};

const sidebarShowReducer = (state = initialSidebarState.sidebarShow, action) => {
  if (action.type === 'set' && 'sidebarShow' in action) {
    return action.sidebarShow;
  }
  return state;
};

// Helper function to get initial unfoldable state from localStorage
function getInitialUnfoldableState() {
  try {
    const saved = localStorage.getItem('sidebarUnfoldable');
    return saved !== null ? JSON.parse(saved) : false;
  } catch (error) {
    console.warn('Error loading sidebarUnfoldable from localStorage:', error);
    return false;
  }
}

const sidebarUnfoldableReducer = (state = getInitialUnfoldableState(), action) => {
  if (action.type === 'set' && 'sidebarUnfoldable' in action) {
    // Save to localStorage when the state changes
    localStorage.setItem('sidebarUnfoldable', JSON.stringify(action.sidebarUnfoldable));
    return action.sidebarUnfoldable;
  }
  return state;
};

const asideShowReducer = (state = initialSidebarState.asideShow, action) => {
  if (action.type === 'set' && 'asideShow' in action) {
    return action.asideShow;
  }
  return state;
};

const rootReducer = combineReducers({
  account: reducer,
  form: reduxFormReducer,
  advertiser: AdvertiserReducer,
  advertisers: AdvertisersReducer,
  components: ComponentsReducer,
  landingPage: LandingPageReducer,
  landingPageGroup: LandingPageGroupReducer,
  offerWall: OfferWallReducer,
  offerState: OfferTitleReducer,
  offerAction: OfferActionReducer,
  offerWallAd: OfferWallAdReducer,
  advertiserPrePing: AdvertiserPrePingReducer,
  criteria: CriteriaReducer,
  metadata: MetadataReducer,
  sequence: SequenceReducer,
  tags: TagsReducer,
  formSelector: FormSelectorReducer,
  // Add the sidebar reducers
  sidebarShow: sidebarShowReducer,
  sidebarUnfoldable: sidebarUnfoldableReducer,
  asideShow: asideShowReducer,
});

export default rootReducer;
